import { create } from 'zustand'
import { GlobalStatistics, ClientsGraphData, ClientsStatusGraphData, GraphDto } from '@/types'
import { statisticsService } from '@/services/statistics.service'

interface StatisticsState {
  globalStatistics: GlobalStatistics | null
  clientsGraph: ClientsGraphData | null
  clientsStatusGraph: ClientsStatusGraphData | null
  isLoading: boolean
  isInitialized: boolean
  fetchGlobalStatistics: () => Promise<void>
  fetchClientsGraph: (graphDto?: GraphDto) => Promise<void>
  fetchClientsStatusGraph: (graphDto?: GraphDto) => Promise<void>
}

export const useStatisticsStore = create<StatisticsState>((set, get) => ({
  globalStatistics: null,
  clientsGraph: null,
  clientsStatusGraph: null,
  isLoading: false,
  isInitialized: false,

  fetchGlobalStatistics: async () => {
    // Only fetch if not already initialized
    if (get().isInitialized) {
      return
    }

    set({ isLoading: true })
    try {
      const data = await statisticsService.getGlobalStatistics()
      set({ globalStatistics: data, isInitialized: true })
    } catch (error) {
      console.error('Error fetching global statistics:', error)
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

  fetchClientsGraph: async (graphDto?: GraphDto) => {
    set({ isLoading: true })
    try {
      const data = await statisticsService.getClientsGraph(graphDto)
      set({ clientsGraph: data })
    } catch (error) {
      console.error('Error fetching clients graph:', error)
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

  fetchClientsStatusGraph: async (graphDto?: GraphDto) => {
    set({ isLoading: true })
    try {
      const data = await statisticsService.getClientsStatusGraph(graphDto)
      set({ clientsStatusGraph: data })
    } catch (error) {
      console.error('Error fetching clients status graph:', error)
      throw error
    } finally {
      set({ isLoading: false })
    }
  },
}))

